import Cookies from 'js-cookie';

const HVPR_CONTROL_TTARP = '844-221-2538';
const CONTROL_TTARP = '855-256-1652';
const ttarpOverrideCookie = Cookies.get('ttarp_override');
export const serviceNumberControl = ttarpOverrideCookie
  ? (ttarpOverrideCookie === '855-792-1402' ? HVPR_CONTROL_TTARP : ttarpOverrideCookie)
  : CONTROL_TTARP;
